import type { BookingPeriodDataApiType } from '@naturehouse/design-system/components/atoms/period/models/BookingPeriodModel';
import UnavailableMethodException from '@naturehouse/nh-essentials/lib/exceptions/UnavailableMethodException';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../../common/CollectionBase';
import { PeriodStorageCollectionType } from '../app/PeriodStorageManager';
import type { BasePeriodCollectionParamsType } from './BasePeriodCollectionParams.type';

export type PeriodBookingCollectionParamsType = BasePeriodCollectionParamsType;

export type PeriodBookingCollectionDataType = null;

export default class PeriodBookingCollection extends CollectionBase<
    PeriodBookingCollectionDataType,
    PeriodBookingCollectionParamsType
> {
    protected name = PeriodStorageCollectionType.BOOKING;

    static #instance: PeriodBookingCollection | null = null;

    public static getInstance(): PeriodBookingCollection {
        if (this.#instance === null) {
            this.#instance = new PeriodBookingCollection();
        }

        return this.#instance;
    }

    public async retrieve<RT = BookingPeriodDataApiType[]>(
        params?: PeriodBookingCollectionParamsType
    ): Promise<RT | void> {
        return super.retrieve<RT>(params);
    }

    public add<RT = AjaxResponse>(): Promise<RT | void> {
        throw new UnavailableMethodException();
    }

    public async delete(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async update(): Promise<void> {
        throw new UnavailableMethodException();
    }

    protected endpoint(params: PeriodBookingCollectionParamsType): string {
        if (!params || !params.houseId) {
            throw new Error('houseId is required');
        }

        return `/api/houses/${params.houseId}/periods/bookings`;
    }

    protected onError(error: HttpError<AjaxResponseError>): void {
        throw new Error(error.body?.message);
    }
}
